import { useQuery } from "@tanstack/react-query";
import { useUnauthenticatedAPI } from "@/api";

export function useBIServerStatus(args: { fetchEvery: number }) {
  const unauthenticatedAPI = useUnauthenticatedAPI();
  return useQuery({
    queryKey: ["status"],
    queryFn: async () => {
      return unauthenticatedAPI.getStatus();
    },
    refetchInterval: args.fetchEvery,
    refetchIntervalInBackground: true,
  });
}
